(function () {
	const _nav = document.getElementById('primary-nav');
	
	let isFix = false;
	let position;
	
	function init() {
		if (!window.hasOwnProperty('getComputedStyle')) {
			return;
		}
		
		if (window.getComputedStyle(_nav).getPropertyValue('position') === 'absolute') {
			getPosition();
			window.addEventListener('scroll', scroll);
		}
		
		window.addEventListener('resize', util.debounce(resize, 300));
	}
	
	function getPosition() {
		position = util.elementPosition(_nav).y;
	}
	
	function reset() {
		_nav.style.position = '';
		_nav.style.top = '';
		
		isFix = false;
	}
	
	function resize() {
		reset();
		
		if (window.getComputedStyle(_nav).getPropertyValue('position') === 'absolute') {
			getPosition();
			scroll();
			
			window.addEventListener('scroll', scroll);
		} else {
			window.removeEventListener('scroll', scroll);
		}
	}
	
	function scroll() {
		if (parseInt(window.pageYOffset || document.documentElement.scrollTop) > position) {
			if (!isFix) {
				_nav.style.position = 'fixed';
				_nav.style.top = 0;
				
				isFix = true;
			}
		} else {
			reset();
		}
	}
	
	init();
}());